// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".media-library-media-svg[data-v-5db4b40c] {\n  max-width: 50%;\n  height: auto;\n  width: auto;\n}", ""]);
// Exports
module.exports = exports;
